import { useAPIQuery, UserContentsDraftPublishApi } from "melco-shared-logic";

export const useFontReferences = (fontId: string) => {
  return useAPIQuery(
    UserContentsDraftPublishApi,
    ["fontReferences", fontId],
    async (api) => api.userAlphabetReferences({ id: fontId })
  );
};
